window.MEPlacementRules = {
  placements: {
    'Left Chest': {
      label: 'Left Chest',
      priceCents: 0,
      variantId: null,
      group: 'front',
      view: 'front',
      width: 3.25,
      dimensions: '3.25″ × 3.25″',
      instructions: 'Pocket-area placement, approximately 3 to 4 inches down from the collar and 3 to 4 inches in from the left seam.',
      assignmentType: 'artwork',
      included: true
    },

    'Center Chest': {
      label: 'Center Chest',
      priceCents: 0,
      variantId: null,
      group: 'front',
      view: 'front',
      width: 12,
      dimensions: '12″ × 4″',
      instructions: 'Centered in the upper third of the front, approximately 2 to 3 inches down from the collar.',
      assignmentType: 'artwork',
      included: true
    },

    'Right Chest': {
      label: 'Right Chest',
      priceCents: 0,
      variantId: null,
      group: 'front',
      view: 'front',
      width: 3.25,
      dimensions: '3.25″ × 3.25″',
      instructions: 'Opposite the left-chest pocket area, approximately 3 to 4 inches down from the collar and 3 to 4 inches in from the right seam.',
      assignmentType: 'artwork',
      included: true
    },

    'Full Front': {
      label: 'Full Front',
      priceCents: 0,
      variantId: null,
      group: 'front',
      view: 'front',
      width: 10.5,
      dimensions: '10″ × 13″',
      instructions: 'Approximately 2 to 3 inches down from the collar and 1 to 1.5 inches in from the side seams.',
      assignmentType: 'artwork',
      included: true
    },

    'Full Back': {
      label: 'Full Back',
      priceCents: 500,
      variantId: 47166600118447,
      group: 'back-print',
      view: 'back',
      width: 10.5,
      dimensions: '12″ × 16″',
      instructions: 'Centered on the back, approximately 2 to 3 inches down from the collar and 1 to 1.5 inches in from the side seams.',
      assignmentType: 'artwork'
    },

    'Upper Back': {
      label: 'Upper Back',
      priceCents: 500,
      variantId: 47166600151215,
      group: 'back-print',
      view: 'back',
      width: 10,
      dimensions: '10″ × 4″',
      instructions: 'Approximately 2 to 3 inches down from the back collar, centered between the shoulder seams.',
      assignmentType: 'artwork'
    },

    'Back Collar': {
      label: 'Back Collar',
      priceCents: 400,
      variantId: 47166600347823,
      group: 'back-print',
      view: 'back',
      width: 4,
      dimensions: '4″ × 2″',
      instructions: 'Centered directly below the back collar seam, approximately 0.5 to 1 inch down.',
      assignmentType: 'artwork'
    },

    'Back Name': {
      label: 'Back Name',
      priceCents: 300,
      variantId: 47168663290031,
      group: 'back-print',
      view: 'back',
      width: 10,
      dimensions: '10″ × 4″',
      instructions: 'Upper-back name placement, approximately 2 to 3 inches down from the collar.',
      assignmentType: 'name-number',
      nameNumberMode: 'name'
    },

    'Back Number': {
      label: 'Back Number',
      priceCents: 400,
      variantId: 47168663290031,
      group: 'back-print',
      view: 'back',
      width: 12,
      dimensions: '12″ × 15″',
      instructions: 'Large full-back number placement, centered below the upper-back area.',
      assignmentType: 'name-number',
      nameNumberMode: 'number'
    },

    'Back Name + Number': {
      label: 'Back Name + Number',
      priceCents: 600,
      variantId: 47168663290031,
      group: 'back-print',
      view: 'back',
      width: 12,
      dimensions: 'Name 10″ × 4″ · Number 12″ × 15″',
      instructions: 'Two production zones: an upper-back name and a centered full-back number.',
      assignmentType: 'name-number',
      nameNumberMode: 'both'
    },

    'Left Sleeve': {
      label: 'Left Sleeve',
      priceCents: 400,
      variantId: 47166600282287,
      group: 'left-sleeve',
      view: 'left-sleeve',
      width: 3,
      dimensions: '3″ × 2″',
      instructions: 'Centered approximately 1 inch above the sleeve hem.',
      assignmentType: 'artwork'
    },

    'Right Sleeve': {
      label: 'Right Sleeve',
      priceCents: 400,
      variantId: 47166600315055,
      group: 'right-sleeve',
      view: 'right-sleeve',
      width: 3,
      dimensions: '3″ × 2″',
      instructions: 'Centered approximately 1 inch above the sleeve hem.',
      assignmentType: 'artwork'
    },

    'Custom Neck Label': {
      label: 'Custom Neck Label',
      priceCents: 500,
      variantId: 47168663322799,
      group: 'neck-label',
      view: 'back',
      width: 3,
      dimensions: '3″ × 2″ maximum',
      instructions:
        'Printed inside the back neck after the original tearaway label is removed. Template preview only; final appearance may vary by garment color and product information.',
      assignmentType: 'artwork'
    }
  }
};